import './css/style.scss';
import './i18n/i18n';

import { b2x } from '@b2x/react/src';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { AssembledComponentSkuTile } from './AssembledComponentSkuTile';
import { Button, ButtonVariant } from './Button';
import { CartSku } from './CartSku';
import { Container } from './Container';
import { en } from './i18n/locales/en';
import { it } from './i18n/locales/it';
import { IconName, IconSize } from './Icon';
import { ThemeColor } from './pages/TemplatePage';
import { PlayIcon } from './PlayIcon';
import { ProductTile, ProductTileBasicInfo, ProductTileExtraInfo } from './ProductTile';
import { reportWebVitals } from './reportWebVitals';
import { ServiceContactsSubpage } from './ServiceContactsSubpage';

b2x.init<ThemeColor, ButtonVariant, IconName, IconSize>({
  analytics: {
    tiktok: {
      debug: true,
    },
  },
  api: {
    apiKey: 'GJDDJFBAABHDCABDGBIDFI',
    productPopulate: {
      alternativeImages: true,
      attributes: true,
      brand: true,
      priceRange: true,
      reviews: true,
      skus: {
        alternativeImages: true,
        attributes: true,
        measurement: true,
        price: true,
        product: {
          attributeGroups: true,
          attributes: true,
          brand: true,
        },
      },
      variantProducts: {
        attributes: true,
      },
    },
    productTilePopulate: {
      alternativeImages: true,
      attributes: true,
      brand: true,
      priceRange: true,
      skus: {
        alternativeImages: true,
        attributes: true,
        measurement: true,
        price: true,
      },
      variantProducts: {
        attributes: true,
        skus: {
          attributes: true,
          measurement: true,
          price: true,
        },
      },
    },
    sessionOptions: {
      populate: {
        cart: {
          packs: {
            cartSkus: {
              assembledComponents: {
                sku: {
                  product: true,
                },
              },
              giftCard: true,
              sku: {
                product: true,
              },
            },
          },
          shippingProfile: true,
        },
        customer: true,
        // wishlist: { products: true, skus: { product: true } },
      },
    },
  },
  defaultButtonVariant: 'outline-primary',
  enableCientSideComingSoonManagement: true,
  enableRightOfWithdrawal: true,
  enableWishlist: false,
  form: {
    buttons: {
      cancel: {
        defaultVariant: 'outline-primary',
      },
      submit: {
        defaultVariant: 'outline-primary',
      },
    },
    showPlaceholder: true,
  },
  i18n: {
    en: en,
    it: it,
  },
  icons: {
    arrow: {
      bottom: 'arrow-down',
      left: 'light-arrow-left',
      right: 'light-arrow-right',
      top: 'arrow-up',
    },
    cart: 'cart',
    close: 'close',
    configurator: 'settings',
    decrement: 'minus',
    download: 'download',
    increment: 'plus',
    info: 'info',
    logout: 'logout',
    passwordToggle: {
      hidden: 'hidden',
      visible: 'visible',
    },
    shipping: 'shipping',
    slider: {
      arrow: {
        left: 'light-arrow-left',
        right: 'light-arrow-right',
      },
    },
  },
  installmentPaymentBanner: {
    paypal: {
      enabled: true,
      layout: 'text',
    },
  },
  iubenda: {
    languages: [
      {
        cookiePolicyId: 59404722,
        languageCode: 'it',
        preferred: true,
      },
      {
        cookiePolicyId: 11069608,
        languageCode: 'en',
        preferred: false,
      },
    ],
    showPrivacyPolicy: false,
    siteId: '3976393',
  },
  paypal: {
    merchantClientId: 'AS-zz8zfHI-6-jFIsCMZd2J5R_jO4U9qywhakSJWGiDVuFhlWwgB1UKv1lRSdg0k25CXwt481-mbbp1y',
  },
  preRelease: true,
  preselectFirstAvailableSku: true,
  productImageAspectRatio: 1,
  projectName: 'bbskill',
  ui: 'bs5',
  variants: {
    AccountHomePage: 'A',
    AccountOffcanvas: 'A',
    AddressFieldset: 'A',
    AssembledComponentSkuTile: AssembledComponentSkuTile,
    Button: Button,
    CartAddressFromAddressBookForm: 'A',
    CartAddressesForm: 'A',
    CartSku: CartSku,
    ChangePasswordForm: 'A',
    Container: Container,
    CustomerAddressForm: 'A',
    CustomerForm: 'B',
    HeaderCheckout: 'B',
    InvoiceFieldset: 'A',
    LocaleForm: 'A',
    LoginForm: 'A',
    OrderDetails: 'A',
    OrderGuestForm: 'A',
    ProductStickyFooter: 'D',
    ProductTile: ProductTile,
    ProductTileBasicInfo: ProductTileBasicInfo,
    ProductTileExtraInfo: ProductTileExtraInfo,
    ServiceContactsSubpage: ServiceContactsSubpage,
  },
  video: {
    PlayIcon: PlayIcon,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <b2x.router.BrowserRouter>
      <b2x.ModalsContext>
        <App />
      </b2x.ModalsContext>
    </b2x.router.BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
